"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROXY_OBJECT_KEYS = void 0;
exports.PROXY_OBJECT_KEYS = {
    path: Symbol(),
    parent: Symbol()
};
